export { BdcCategory } from "./pages/bdccategory";
